import { Documentation } from 'graphql-common';
import { NavItem, NavItemTypeEnum } from '@lib/components/Menu/Menu';
import Icons from '@lib/components/Icons/Icons';
import { hasTextEditorValue } from '@lib/components/TextEditor/utils';

export default function getDocumentActionsNavItems({
  doc,
  onViewDocument,
  onVersionNotes,
  onDetails,
  t,
}: {
  doc: Documentation;
  onViewDocument: (item: Documentation) => void;
  onVersionNotes: (item: Documentation) => void;
  onDetails: (item: Documentation) => void;
  t: (key: string) => string;
}): NavItem<Documentation>[] {
  return [
    {
      id: 'view-document',
      title: t('view-document'),
      onClick: () => onViewDocument(doc),
      leftIcon: Icons.description,
      type: NavItemTypeEnum.Secondary,
    },
    {
      id: 'version-notes',
      title: t('version-notes'),
      onClick: () => onVersionNotes(doc),
      leftIcon: Icons.pendingActions,
      type: NavItemTypeEnum.Secondary,
      disabled: !hasTextEditorValue(doc.currentVersion?.notes),
    },
    {
      id: 'details',
      title: t('details'),
      onClick: () => onDetails(doc),
      leftIcon: Icons.view,
      type: NavItemTypeEnum.Secondary,
    },
  ];
}
